import { useState } from 'react';
import { AiFillWarning } from 'react-icons/ai';

import UserService from '@/services/user.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import OrderCard from '@/shared-components/cards/components/OrderCard';
import AddReview from '@/shared-components/forms/add-review';

import ReportIssue from './report-issue';

import './index.css';

export default function SentOrderCard({ orderData, onConfirmReception, onReportIssue, onViewIssue }) {
  const [openConfirmReception, setOpenConfirmReception] = useState(false);
  const [openReportIssueForm, setOpenReportIssueForm] = useState(false);
  const [formLoading, setFormLoading] = useState(false);

  async function onWriteReview(review) {
    setFormLoading(true);

    const { response } = await UserService.confirmReception(orderData.order_number, review.comment);

    if (response.ok) {
      onConfirmReception(orderData._id);
    }
  }

  return (
    <>
      <OrderCard
        orderData={orderData}
        navigateToView
        headerAction={orderData.order_issue ? (
          <button
            type="button"
            className="sent-order-card__issue-trigger element-non-selectable"
            aria-label="View issue details"
            title="View issue details"
            onClick={(event) => {
              event.stopPropagation();
              onViewIssue?.();
            }}
          >
            <AiFillWarning aria-hidden="true" />
          </button>
        ) : null}
      >
        <div className={`sent-order-card__buttons element-non-selectable ${orderData.order_issue ? "single" : ""}`}>
          <ContinueButton 
            loading={formLoading} 
            className="sent-order-card__button"
            onClick={() => setOpenConfirmReception(true)}
          >
            Confirm reception
          </ContinueButton>

          {!orderData.order_issue && (
            <ContinueButton 
              className="sent-order-card__button"
              onClick={() => setOpenReportIssueForm(true)}
            >
              Report an issue
            </ContinueButton>
          )}
        </div>
      </OrderCard>

      <AddReview
        headerText="Confirm reception"
        artworkToReview={orderData.order_artwork}
        typeOfArtwork={orderData.order_limited_edition_data ? "limited_edition" : "original"}
        open={Boolean(openConfirmReception)}
        close={() => setOpenConfirmReception(false)}
        onReview={onWriteReview}
      />

      <ReportIssue
        open={openReportIssueForm}
        close={() => setOpenReportIssueForm(false)}
        orderData={orderData}
        onReportIssue={onReportIssue}
      />
    </>
  );
}
